import React, { useState, useEffect } from "react";
import "../styles/AdminCalendarModal.css";
import { format } from "date-fns";
import axios from "axios";

const AdminCalendarModal = ({ event, onClose, onEdit, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  // Form state
  const [formData, setFormData] = useState({
    session_title: "",
    session_description: "",
    session_date: "",
    start_time: "",
    end_time: "",
    room_id: "",
    lecturer_id: "",
  });
  // State to hold rooms
  const [rooms, setRooms] = useState([]);
  //State to hold lecturers
  const [lecturers, setLecturers] = useState([]);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/getData/rooms`);
        setRooms(res.data);
      } catch (err) {
        console.error("Błąd przy pobieraniu sal:", err);
      }
    };
    fetchRooms();
  }, []);

    useEffect(() => {
    const fetchLecturers = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/getData/lecturers`);
        setLecturers(res.data);
      } catch (err) {
        console.error("Błąd przy pobieraniu wykładowców:", err);
      }
    };
    fetchLecturers();
  }, []);

  useEffect(() => {
    if (event) {
      setFormData({
        session_title: event.session_title || "",
        session_description: event.session_description || "",
        session_date: format(event.start, "yyyy-MM-dd"),
        start_time: format(event.start, "HH:mm"),
        end_time: format(event.end, "HH:mm"),
        room_id: event.room_id ?? undefined,
        lecturer_id: event.lecturer_id ?? undefined,
      });
    }
  }, [event]);


  if (!event) return null;

  const handleSave = () => {
    const start = new Date(`${formData.session_date}T${formData.start_time}:00`);
    const end = new Date(`${formData.session_date}T${formData.end_time}:00`);

    onEdit({
      ...event,
      session_title: formData.session_title,
      session_description: formData.session_description,
      start,
      end,
      room_id: formData.room_id === "" ? null : formData.room_id,
      lecturer_id: formData.lecturer_id === "" ? null : formData.lecturer_id,
    });
    console.log('formData', formData);
  };

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal-box">
        <div className="admin-modal-content">
          {!isEditing ? (
            <>
              <h2 className="admin-modal-title"><strong>{event.module_name}</strong></h2>
              <p className="admin-modal-description"><strong>{event.session_title}</strong></p>
              <p className="admin-modal-description"><strong>Grupa:</strong> {event.group_code} ({event.group_name})</p>
              <p className="admin-modal-description"><strong>Nauczyciel:</strong> {event.lecturer || 'Brak nauczyciela'}</p>
              <p className="admin-modal-description"><strong>Sala:</strong> {event.room_name || 'Brak sali'}</p>
              <p className="admin-modal-description"><strong>Data:</strong> {format(event.start, 'dd.MM.yyyy')}</p>
              <p className="admin-modal-description"><strong>Godzina:</strong> {format(event.start, 'HH:mm')} - {format(event.end, 'HH:mm')}</p>
              <p className="admin-modal-description"><strong>Opis:</strong> {event.session_description || 'Brak opisu'}</p>
            </>
          ) : (
            <>
              <h2 className="admin-modal-title">Edytuj wydarzenie ({event.module_name})</h2>

              <div className="admin-form-group">
                <label>Tytuł</label>
                <input
                  className="form-input"
                  type="text" 
                  name="session_title" 
                  value={formData.session_title} 
                  onChange={(e) => setFormData({ ...formData, session_title: e.target.value })} 
                />
              </div>

              <div className="admin-form-group">
                <label>Sala</label>
                <select
                  value={formData.room_id}
                  onChange={(e) => setFormData({ ...formData, room_id: Number(e.target.value) })}
                  className="form-input"
                >
                  <option value="">-- wybierz --</option>
                  {rooms.map((room) => (
                    <option key={room.room_id} value={room.room_id}>
                      {room.room_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-form-group">
                <label>Wykładowca</label>
                <select
                  value={formData.lecturer_id}
                  onChange={(e) => setFormData({ ...formData, lecturer_id: Number(e.target.value) })}
                  className="form-input"
                >
                  <option value="">-- wybierz --</option>
                  {lecturers.map((lecturer) => (
                    <option key={lecturer.lecturer_id} value={lecturer.lecturer_id}>
                      {lecturer.academic_position} {lecturer.first_name} {lecturer.last_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-form-group">
                <label>Data</label>
                <input
                  className="form-input"
                  type="date"
                  value={formData.session_date}
                  onChange={(e) => setFormData({ ...formData, session_date: e.target.value })}
                />
              </div>

              <div className="admin-form-group">
                <label>Godzina startu</label>
                <input
                  className="form-input"
                  type="time"
                  value={formData.start_time}
                  onChange={(e) => setFormData({ ...formData, start_time: e.target.value })}
                />
              </div>

              <div className="admin-form-group">
                <label>Godzina zakończenia</label>
                <input
                  className="form-input"
                  type="time"
                  value={formData.end_time}
                  onChange={(e) => setFormData({ ...formData, end_time: e.target.value })}
                />
              </div>
              
              <div className="admin-form-group">
                <label>Opis</label>
                <textarea 
                  className="form-input"
                  name="session_description" 
                  value={formData.session_description} 
                  onChange={(e) => setFormData({ ...formData, session_description: e.target.value })}
                >
                </textarea>
              </div>
            </>
          )}
        </div>
        <div className="admin-modal-actions">
          {!isEditing ? (
            <>
              <button onClick={() => setIsEditing(true)} className="btn btn-edit">Edytuj</button>
              <button onClick={() => onDelete(event)} className="btn btn-delete">Usuń</button>
              <button onClick={onClose} className="btn btn-close">Zamknij</button>
            </>
          ) : (
            <>
              <button onClick={handleSave} className="btn btn-edit">Zapisz</button>
              <button onClick={() => setIsEditing(false)} className="btn btn-close">Anuluj</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCalendarModal;
